<div class="modal-header bg-dark text-white">
  <h3 class="modal-title" id="modal-basic-title">Import Tender Bids</h3>
  <div class="ms-auto" data-bs-theme="dark">
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
</div>
<div class="modal-body position-relative">
  <!-- Import Instructions (shown before import and validation) -->
  <div *ngIf="!isProcessing">
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <svg class="svg-fill-dark" width="64px" height="64px" viewBox="0 0 32 32" version="1.1"
              xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <title>number</title>
                <path
                  d="M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM16 27c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11zM14.828 12.709c-0.589 0.458-1.134 0.77-1.635 0.934v1.742c0.953-0.314 1.781-0.799 2.484-1.455v7.111h2.047v-10h-1.686c-0.218 0.612-0.622 1.209-1.21 1.668z">
                </path>
              </g>
            </svg>
          </div>
          <div class="flex-grow-1 ms-3">
            <!--            Tender bid import airline version-->
            <div [hidden]="loadingTemplate">
              <div class="d-flex align-items-end gap-2">
                <div class="flex-grow-1">
                  <label class="form-label mb-1">Select supplier user (required)</label>
                  <ng-select [items]="supplierUsers$ | async" [clearable]="true" [searchable]="true"
                    [loading]="loadingUsers" [openOnEnter]="true" [openOnClick]="true"
                    (change)="onSupplierSelected($event)" (search)="supplierUserSearch$.next($event.term)"
                    (open)="onDropdownOpen()" bindLabel="company.name" [trackByFn]="trackUser"
                    placeholder="Select supplier by company or name...">
                    <ng-template ng-option-tmp let-item="item">
                      <div><span class="fw-bold">{{ item.company?.name }}</span><br>
                        <small class="text-muted">{{ (item.first_name || item.firstName) }} {{ (item.last_name ||
                          item.lastName) }}<br>
                          {{ item.email }}</small>
                      </div>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item">
                      <span class="fw-bold">{{ item.company?.name }}</span> - {{ (item.first_name || item.firstName) }}
                      {{ (item.last_name || item.lastName) }}
                    </ng-template>
                  </ng-select>
                </div>
                <button type="button" (click)="exportTenderInfo($event)" class="btn btn-primary text-white"
                  [disabled]="!templateFileVersion || !supplierUserId" title="Download Excel Bid Template">
                  <ng-icon name="lucideDownload" class="me-1"></ng-icon> Excel Bid Template <span
                    *ngIf="templateFileVersion">{{templateFileVersion}}</span>
                </button>
              </div>
            </div>

            <div [hidden]="!loadingTemplate">
              <button class="btn btn-outline-secondary" type="button" disabled>
                <span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
                <span role="status" class="ms-2">Generating Excel Bid Template for <span class="fw-bold">{{
                    supplierCompanyName || 'Selected Supplier' }}</span></span>
              </button>
              <p class="text-muted small mb-0">Please wait, time may vary depending on the number of tender locations.
              </p>
            </div>

          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <svg class="svg-fill-dark" width="64px" height="64px" viewBox="0 0 32 32" version="1.1"
              xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <title>number1</title>
                <path
                  d="M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM16 27c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11zM17.564 17.777c0.607-0.556 1.027-0.982 1.26-1.278 0.351-0.447 0.607-0.875 0.77-1.282 0.161-0.408 0.242-0.838 0.242-1.289 0-0.793-0.283-1.457-0.848-1.99s-1.342-0.8-2.331-0.8c-0.902 0-1.654 0.23-2.256 0.69s-0.96 1.218-1.073 2.275l1.914 0.191c0.036-0.56 0.173-0.96 0.41-1.201s0.555-0.361 0.956-0.361c0.405 0 0.723 0.115 0.952 0.345 0.23 0.23 0.346 0.56 0.346 0.988 0 0.387-0.133 0.779-0.396 1.176-0.195 0.287-0.727 0.834-1.592 1.64-1.076 0.998-1.796 1.799-2.16 2.403s-0.584 1.242-0.656 1.917h6.734v-1.781h-3.819c0.101-0.173 0.231-0.351 0.394-0.534 0.16-0.183 0.545-0.552 1.153-1.109z">
                </path>
              </g>
            </svg>
          </div>
          <div class="flex-grow-1 ms-3">
            Follow the guidelines in the document to add bid information to the template
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <svg class="svg-fill-dark" width="64px" height="64px" viewBox="0 0 32 32" version="1.1"
              xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <title>number2</title>
                <path
                  d="M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM16 27c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11zM17.248 15.219c0.963-0.525 1.443-1.228 1.443-2.108 0-0.621-0.234-1.177-0.705-1.67-0.571-0.602-1.33-0.903-2.275-0.903-0.553 0-1.052 0.104-1.497 0.311s-0.792 0.493-1.042 0.855c-0.248 0.362-0.435 0.847-0.559 1.454l1.773 0.302c0.051-0.439 0.193-0.772 0.426-1.001s0.516-0.343 0.845-0.343c0.334 0 0.603 0.101 0.804 0.301 0.201 0.201 0.302 0.471 0.302 0.809 0 0.398-0.138 0.716-0.413 0.957-0.273 0.24-0.673 0.353-1.195 0.339l-0.213 1.565c0.344-0.096 0.638-0.144 0.885-0.144 0.374 0 0.691 0.141 0.952 0.423s0.391 0.665 0.391 1.147c0 0.509-0.136 0.914-0.407 1.214s-0.607 0.45-1.004 0.45c-0.37 0-0.686-0.125-0.945-0.375-0.261-0.25-0.42-0.612-0.479-1.086l-1.859 0.226c0.096 0.843 0.442 1.525 1.040 2.047s1.35 0.782 2.258 0.782c0.957 0 1.758-0.309 2.401-0.929s0.965-1.368 0.965-2.247c0-0.605-0.172-1.122-0.515-1.55-0.346-0.427-0.804-0.703-1.377-0.826z">
                </path>
              </g>
            </svg>
          </div>
          <div class="flex-grow-1 ms-3">
            Import the updated template with bid data below
          </div>
        </div>
      </li>
    </ul>
    <div *ngIf="!(tender.company.settings.isSealedTender() && !tender.isClosedRounds)" class="uploader-wrap">
      <!-- Import Options -->
      <!-- Import Options (Removed) -->

      <form>
        <div class="form-group">
          <jft-dropzone (filesSelected)="filesSelected($event)" [loading]="loading">
            Drop completed <strong>Bid Template</strong> here
          </jft-dropzone>
        </div>
      </form>
    </div>

    <div class="alert alert-warning d-flex align-items-center" role="alert"
      *ngIf="(tender.company.settings.isSealedTender() && !tender.isClosedRounds)">
      <ng-icon name="lucideTriangleAlert" class="me-2"></ng-icon>
      <div>
        Access restricted for sealed tenders during active rounds
      </div>
    </div>
  </div>

</div>
<div class="modal-footer">
  <button class="btn btn-outline-secondary" (click)="close()">Close</button>
</div>